import React from 'react';

import orderBy from 'lodash.orderby';
import { useFormContext } from 'react-hook-form';

import { FormField } from '@/_components';
import { useBoolean } from '@/_shared';

import { EditSKUs } from './edit';
import { PreviewSKUs } from './preview';

function SKUsFormBase({ isEditable }: { isEditable?: boolean }) {
  const { current: form } = React.useRef(useFormContext());
  const [open, setOpen] = useBoolean();

  return (
    <FormField
      control={form.control}
      name="secondary_skus"
      render={({ field: { value, onChange } }) => {
        const sortedValue = orderBy(value, (item) => item?.pivot?.primary ?? 0, 'desc');
        return (
          <>
            {isEditable && open && (
              <EditSKUs open={open} onClose={setOpen.setFalse} value={sortedValue} onChange={onChange} />
            )}
            <PreviewSKUs value={sortedValue} onOpen={setOpen.setTrue} isEditable={isEditable} />
          </>
        );
      }}
    />
  );
}

export const SKUsForm = React.memo(SKUsFormBase);
